import App from '{p}/App.vue';
export default {
    App
};